// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3jJrK","select":"Header_select__1XkAR","clinic":"Header_clinic__et-GB"};